/**
 * 封面圖 multipart 上傳的共用契約(projects / brand_kits 兩個 service 共用)
 * -----------------------------------------------------------------------------
 * BE docs/92 §2.2。兩邊端點形狀完全一致,只有 path 前綴不同:
 *   `POST /api/projects/{pid}/cover`
 *   `POST /api/brand_kits/{bid}/cover`
 *
 * 抽出來只為了一件事:**欄位名是 wire 契約,不能有兩份**。BE router 是
 * `file: UploadFile = File(...)` → 欄位名必須逐字是 `file`,寫錯不會有型別錯誤、
 * 只會在 runtime 吃 422,而且兩個 service 各寫一份就有漂移的可能。
 */

/** BE `File(...)` 參數名;改這裡要同步改 BE router。 */
export const COVER_FILE_FIELD = 'file';

/** 端點 path 後綴(兩個資源共用)。 */
export const COVER_PATH_SUFFIX = '/cover';

/**
 * 包成 multipart body。
 *
 * ⚠️ 呼叫端**不要**自己設 `Content-Type` —— boundary 只有瀏覽器在送出當下才知道。
 * `httpRequest` 偵測到 `FormData` 就會跳過 Content-Type,詳見該檔的 R245 註解。
 */
export function buildCoverFormData(file: File): FormData {
  const fd = new FormData();
  fd.append(COVER_FILE_FIELD, file);
  return fd;
}
